import { render } from "./ShortcutList.vue?vue&type=template&id=6e83b725&scoped=true"
import script from "./ShortcutList.vue?vue&type=script&lang=js"
export * from "./ShortcutList.vue?vue&type=script&lang=js"

import "./ShortcutList.vue?vue&type=style&index=0&id=6e83b725&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e83b725"]])

export default __exports__